/* tabirou 着回しコーデ — ビューア（縦送り・ドット・?look=）／ピン／スマホのシート／サイズ選択→カート追加 */
(() => {
  const mqDesktop = window.matchMedia('(min-width: 990px)');
  const pad2 = (n) => String(n).padStart(2, '0');

  /* ── トースト ───────────────────────── */
  const toast = (root, html) => {
    const el = root.querySelector('.tsty-toast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 4000);
  };

  /* ── スマホのシート ─────────────────── */
  const openSheet = (root, panel, itemNo) => {
    if (mqDesktop.matches) return;
    root.querySelectorAll('.tsty-panel.is-sheet-open').forEach((p) => p.classList.remove('is-sheet-open'));
    panel.classList.add('is-sheet-open');
    const bd = root.querySelector('.tsty-backdrop');
    if (bd) bd.hidden = false;
    document.documentElement.classList.add('tsty-lock');
    const info = panel.querySelector('.tsty-panel__info');
    if (itemNo) {
      const row = info.querySelector(`.tsty-item[data-item="${itemNo}"]`);
      if (row) requestAnimationFrame(() => { row.scrollIntoView({ block: 'center' }); flash(row); });
    }
    info.querySelector('.tsty-sheet__close')?.focus({ preventScroll: true });
  };
  const closeSheet = (root) => {
    const open = root.querySelector('.tsty-panel.is-sheet-open');
    root.querySelectorAll('.tsty-panel.is-sheet-open').forEach((p) => p.classList.remove('is-sheet-open'));
    const bd = root.querySelector('.tsty-backdrop');
    if (bd) bd.hidden = true;
    document.documentElement.classList.remove('tsty-lock');
    open?.querySelector('[data-open-sheet]')?.focus({ preventScroll: true });
  };

  const flash = (row) => {
    row.classList.remove('is-flash');
    void row.offsetWidth;
    row.classList.add('is-flash');
  };

  /* ── カート追加（Dawn の cart-icon-bubble を差し替えて件数を更新） ── */
  const addToCart = async (root, btn) => {
    const id = Number(btn.dataset.variantId);
    btn.disabled = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-icon-bubble' }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'error');
      const html = data.sections?.['cart-icon-bubble'];
      const bubble = document.getElementById('cart-icon-bubble');
      if (html && bubble) {
        const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      toast(root, `カートに入れました（${btn.textContent.trim()}）　<a href="${window.Shopify?.routes?.root || '/'}cart">カートを見る</a>`);
    } catch (e) {
      toast(root, `カートに入れられませんでした。${e.message === 'error' ? '' : e.message}`);
    } finally {
      btn.disabled = false;
    }
  };

  /* ── 共通の操作（一覧・個別ページ） ─────── */
  const bindCommon = (root) => {
    root.addEventListener('click', (ev) => {
      const t = ev.target;
      const pin = t.closest('.tsty-pin');
      if (pin) {
        const panel = pin.closest('.tsty-panel');
        /* シートになるのはスマホの一覧ビューアだけ。個別ページは行までスクロール */
        if (mqDesktop.matches || !panel.closest('.tsty-viewer')) {
          const row = panel.querySelector(`.tsty-item[data-item="${pin.dataset.item}"]`);
          if (row) { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); flash(row); }
        } else {
          openSheet(root, panel, pin.dataset.item);
        }
        return;
      }
      if (t.closest('[data-open-sheet]')) {
        openSheet(root, t.closest('.tsty-panel'));
        return;
      }
      if (t.closest('[data-close-sheet]')) { closeSheet(root); return; }
      const tog = t.closest('[data-toggle-sizes]');
      if (tog) {
        const box = tog.closest('.tsty-item').querySelector('.tsty-sizes');
        const open = box.hidden;
        box.hidden = !open;
        tog.setAttribute('aria-expanded', String(open));
        tog.classList.toggle('is-open', open);
        return;
      }
      const size = t.closest('.tsty-size');
      if (size && !size.disabled) addToCart(root, size);
    });

    /* ピン ⇄ 行のハイライト */
    const hl = (ev, on) => {
      const el = ev.target.closest?.('.tsty-pin, .tsty-item');
      if (!el) return;
      const panel = el.closest('.tsty-panel');
      panel.querySelectorAll(`[data-item="${el.dataset.item}"]`).forEach((x) => x.classList.toggle('is-hl', on));
    };
    root.addEventListener('pointerover', (e) => hl(e, true));
    root.addEventListener('pointerout', (e) => hl(e, false));
    root.addEventListener('focusin', (e) => hl(e, true));
    root.addEventListener('focusout', (e) => hl(e, false));

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSheet(root); });
    mqDesktop.addEventListener('change', () => closeSheet(root));
  };

  /* ── 一覧ビューア ───────────────────── */
  const initViewer = (root) => {
    const viewer = root.querySelector('.tsty-viewer');
    if (!viewer) return;
    const panels = [...viewer.querySelectorAll('.tsty-panel')];
    const dotsBox = root.querySelector('.tsty-rail__dots');
    const curEl = root.querySelector('[data-current]');
    const totEl = root.querySelector('[data-total]');
    let visible = panels;
    let current = 0;

    /* ビューアの高さ＝画面からビューア上端（ヘッダー＋見出しバー）を引いた分 */
    const fit = () => {
      const top = viewer.getBoundingClientRect().top + window.scrollY;
      const off = Math.min(Math.max(top, 0), window.innerHeight * 0.4);
      root.style.setProperty('--tsty-offset', `${off}px`);
    };
    fit();
    window.addEventListener('resize', fit, { passive: true });

    const go = (i, smooth = true) => {
      const p = visible[Math.max(0, Math.min(i, visible.length - 1))];
      if (p) viewer.scrollTo({ top: p.offsetTop, behavior: smooth ? 'smooth' : 'auto' });
    };

    const renderDots = () => {
      dotsBox.innerHTML = '';
      visible.forEach((p, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tsty-rail__dot';
        b.setAttribute('aria-label', `LOOK ${pad2(i + 1)}`);
        b.addEventListener('click', () => go(i));
        dotsBox.appendChild(b);
      });
      totEl.textContent = `/ ${pad2(visible.length)}`;
    };

    const setCurrent = (i) => {
      current = i;
      curEl.textContent = pad2(i + 1);
      [...dotsBox.children].forEach((d, j) => d.setAttribute('aria-current', String(j === i)));
      const handle = visible[i]?.dataset.handle;
      if (handle) {
        const u = new URL(window.location.href);
        if (u.searchParams.get('look') !== handle) {
          u.searchParams.set('look', handle);
          history.replaceState(history.state, '', u);
        }
      }
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          const i = visible.indexOf(en.target);
          if (i >= 0) setCurrent(i);
        }
      });
    }, { root: viewer, threshold: 0.6 });
    panels.forEach((p) => io.observe(p));

    root.querySelectorAll('.tsty-rail__arrow').forEach((b) => b.addEventListener('click', () => go(current + Number(b.dataset.step))));
    viewer.addEventListener('keydown', (e) => {
      if (e.target.closest('.tsty-panel__info') && mqDesktop.matches === false) return;
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); go(current - 1); }
    });

    /* シーン絞り込み */
    root.querySelectorAll('.tsty-filter__btn').forEach((b) => b.addEventListener('click', () => {
      const s = b.dataset.scene;
      root.querySelectorAll('.tsty-filter__btn').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      panels.forEach((p) => { p.hidden = s !== 'all' && p.dataset.scene !== s; });
      visible = panels.filter((p) => !p.hidden);
      renderDots();
      setCurrent(0);
      go(0, false);
    }));

    renderDots();
    const want = new URL(window.location.href).searchParams.get('look');
    const start = Math.max(0, visible.findIndex((p) => p.dataset.handle === want));
    setCurrent(start);
    if (start > 0) {
      go(start, false);
      viewer.scrollIntoView({ block: 'end' });
    }
  };

  /* 落書きの文字が写真の外に出たら反対側へ回す（狭い画面で左右の端に寄ったとき） */
  const fitDoodles = () => {
    document.querySelectorAll('.tsty-doodle').forEach((d) => {
      const stage = d.closest('.tsty-stage, .tsty-card__media');
      const label = d.querySelector('.tsty-doodle__label');
      if (!stage || !label || stage.offsetWidth === 0) return;
      const s = stage.getBoundingClientRect();
      const out = () => { const r = label.getBoundingClientRect(); return r.left < s.left + 4 || r.right > s.right - 4; };
      if (out()) {
        d.classList.toggle('tsty-doodle--left');
        d.classList.toggle('tsty-doodle--right');
        if (out()) { d.classList.toggle('tsty-doodle--left'); d.classList.toggle('tsty-doodle--right'); }
      }
    });
  };

  /* 入口のカルーセル（2026-10-06 作り直し）
     ・ループ：カードを1組複製して後ろに足し、先頭の組を通り過ぎたら1組ぶん戻す（見た目は同じなので継ぎ目が出ない）
     ・送りは約1秒かけてゆるやかに（ネイティブの smooth は速すぎて「一気に動く」と言われた）
     ・自動送りは data-autoplay 秒ごとに1枚。乗せている・触った直後・画面外・視差効果を減らす設定では止める */
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const initCarousels = () => {
    document.querySelectorAll('[data-tsty-carousel]').forEach((track) => {
      const root = track.closest('.tsty-teaser') || document;
      const btns = root.querySelectorAll('[data-carousel-step]');
      const originals = [...track.children];
      if (originals.length < 2) return;
      // 複製は読み上げ・フォーカスの対象から外す。表示アニメーション（ookami-anim）は付け直さず最初から見せる
      originals.forEach((li) => {
        const c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.classList.remove('ookami-anim');
        c.classList.add('is-visible');
        c.style.transitionDelay = '';
        c.querySelectorAll('a, button').forEach((a) => a.setAttribute('tabindex', '-1'));
        track.appendChild(c);
      });
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      const stepW = () => {
        const card = track.querySelector('.tsty-card');
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0') : track.clientWidth;
      };
      const setW = () => stepW() * originals.length;
      // 1組ぶんを超えたら同じ見た目の位置へ戻す
      const wrap = () => {
        const w = setW();
        if (track.scrollLeft >= w) track.scrollLeft -= w;
        else if (track.scrollLeft < 0) track.scrollLeft += w;
      };
      let anim = 0;
      const animateTo = (target, ms = 1000) => {
        cancelAnimationFrame(anim);
        const from = track.scrollLeft, d = target - from, t0 = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - t0) / ms);
          track.scrollLeft = from + d * ease(t);
          if (t < 1) anim = requestAnimationFrame(tick); else wrap();
        };
        anim = requestAnimationFrame(tick);
      };
      const go = (n) => {
        const st = stepW();
        // 後ろへ送るとき先頭にいたら、先に1組ぶん先の同じ位置へ移っておく
        if (n < 0 && track.scrollLeft < st * Math.abs(n)) track.scrollLeft += setW();
        const idx = Math.round(track.scrollLeft / st);
        animateTo((idx + n) * st);
      };
      let touchedAt = 0;
      btns.forEach((b) => {
        b.disabled = false;
        b.addEventListener('click', () => {
          touchedAt = Date.now();
          // 1回押すと1枚（3枚まとめて送ると「一気に進む」と言われた・2026-10-07）
          go(Number(b.dataset.carouselStep));
        });
      });
      // 指で送ったあとも継ぎ目を越えたら戻す
      let idle = 0;
      track.addEventListener('scroll', () => { clearTimeout(idle); idle = setTimeout(wrap, 150); }, { passive: true });
      track.addEventListener('touchstart', () => { touchedAt = Date.now(); cancelAnimationFrame(anim); }, { passive: true });
      track.addEventListener('wheel', () => { touchedAt = Date.now(); }, { passive: true });

      const sec = Number(track.dataset.autoplay || 0);
      if (sec > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let inView = false;
        new IntersectionObserver((es) => es.forEach((e) => { inView = e.isIntersecting; }), { threshold: 0.4 }).observe(track);
        setInterval(() => {
          // 止めるのは「乗せている間」「キーボードで操作している間（:focus-visible）」「触った直後3秒」だけ。
          // マウスでボタンを押したあとのフォーカスでは止めない（押した後ずっと止まったままになっていた・2026-10-07）
          const keyboard = Boolean(root.querySelector(':focus-visible'));
          if (root.matches(':hover') || keyboard || !inView || document.hidden || Date.now() - touchedAt < 3000) return;
          go(1);
        }, sec * 1000);
      }
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-tsty-viewer]').forEach((r) => { bindCommon(r); initViewer(r); });
    document.querySelectorAll('[data-tsty-single]').forEach((r) => bindCommon(r));
    fitDoodles();
    initCarousels();
    document.fonts?.ready.then(fitDoodles);
    window.addEventListener('resize', fitDoodles, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
